
import EazyHeading from '@/components/EazyHeading.vue';
import WelcomeHeading from '@/components/WelcomeHeading.vue';
import requestAPI from '@/logic/requestBeApi';
import Timeline from '@/views/Timeline/Timeline.vue';

export default {
  name: 'CandidateAssessments',
  components: {
    EazyHeading,
    WelcomeHeading,
    Timeline,
  },
  data(): Record<string, unknown> {
    return {
      candidate: {
        first_name: '',
        surname: '',
        profile_picture: {
          url: '',
        },
      },
      assessments: [],
      activeCollapse: '',
      timelineLoaded: true,
      assessmentsLoaded: false,
      firstClick: true,
    };
  },
  computed: {
    candidateId(): string {
      return localStorage.getItem('userId');
    },
  },
  async created(): Promise<void> {
    this.getCandidateData(this.candidateId);
  },
  methods: {
    handleCollapseClick(assessmentId): void {
      this.activeCollapse = '';
      if (this.firstClick) {
        this.timelineLoaded = false;
      }
      this.activeCollapse = this.activeCollapse === assessmentId ? '' : assessmentId;
      if (this.firstClick) {
        setTimeout(() => {
          this.timelineLoaded = true;
        }, 3000);
        this.firstClick = false;
      }
    },
    handleTimelineLoaded(): void {
      this.loading = false;
    },
    async getCandidateData(candidateId: string): Promise<void> {
      const resp = await requestAPI({ method: 'GET', url: `/api/v1/candidates/${candidateId}` });

      if (resp.ok) {
        const data = await resp.json();
        this.candidate = {
          first_name: data.first_name,
          surname: data.surname,
          profile_picture: {
            url: data.profile_picture?.url || '',
          },
        };
        await this.getAssessmentsData();
      } else if (resp.status !== 401) this.$message.error(this.$t('someErrorOccurred'));
    },
    async getAssessmentsData(): Promise<void> {
      const resp = await requestAPI({ method: 'GET', url: `/api/v1/assessments` });
      if (resp.ok) {
        const assessmentData = await resp.json();
        for (const assessment of assessmentData) {
          this.assessments.push({
            assessmentId: assessment.id,
            assessmentName: assessment.client.company_name,
          });
        }
      }
      this.assessmentsLoaded = true;
    },
  },
};
